import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=bdaed4aa&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=bdaed4aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdaed4aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdaed4aa')) {
      api.createRecord('bdaed4aa', component.options)
    } else {
      api.reload('bdaed4aa', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=bdaed4aa&scoped=true&", function () {
      api.rerender('bdaed4aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2jhbTJFp7KWnj/JS/comp/GuestBox.vue"
export default component.exports